import styled from '@emotion/styled';
import { Tooltip, Typography } from '@material-ui/core';
import Help from '@material-ui/icons/Help';
import { ClassAttributes, createElement, ReactNode } from 'react';

import theme from '../../../../theme';
import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';

interface Props {
  section: {
    label: string;
    meta?: any | null;
  };
  className?: string;
  children: ReactNode;
}

const CreativeBriefDetailCardSection = ({ section, className, children }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <Title variant="h6">
      {section.label}
      {section.meta && section.meta.helperUrlForDirector ? (
        section.meta.helperTooltipForDirector ? (
          <Tooltip title={section.meta.helperTooltipForDirector} placement="top">
            <HelpAnchor href={section.meta.helperUrlForDirector} target="_blank" rel="noopener noreferrer">
              <HelpIcon />
            </HelpAnchor>
          </Tooltip>
        ) : (
          <HelpAnchor href={section.meta.helperUrlForDirector} target="_blank" rel="noopener noreferrer">
            <HelpIcon />
          </HelpAnchor>
        )
      ) : null}
    </Title>

    <Fields>{children}</Fields>
  </Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto', '1fr'],
    areas: [['section_title'], ['fields']],
  }),
);

const Title = styled(Typography)(gridLayoutItem('section_title'), { marginBottom: SPACING_UNIT * 3 });

const Fields = styled('div')(gridLayoutItem('fields'), flexibleLayoutContainer({ direction: 'column' }), {
  '& > *': {
    marginBottom: SPACING_UNIT * 5,
  },
  '& > *:last-child': {
    marginBottom: 0,
  },
});

const HelpAnchor = styled('a')({
  display: 'inline-flex',
  alignItems: 'center',
  verticalAlign: '-0.2rem',
  marginLeft: SPACING_UNIT,
  color: theme.palette.secondary.main,
  textDecoration: 'none',
});

const HelpIcon = styled(Help)({
  marginRight: 2,
  fontSize: 20,
});

export default CreativeBriefDetailCardSection;
